import React from "react";

import WelcomeContainer from "components/WelcomeContainer";
import Camera from "components/Camera";
import Modal from "components/Modal";
import { useSelector } from "react-redux";
import Cookie from "universal-cookie";
import { useHistory } from "react-router-dom";
import Countdown from "react-countdown";

const cookie = new Cookie();

export default function Welcome(props) {
  const general = useSelector((state) => state.general);
  const history = useHistory();

  const TOTAL_TIME = 25 * 60 * 1000;

  const getRemaining = () => {
    const startTime = cookie.get("start_time_bod");
    if (!startTime) return TOTAL_TIME;
    const elapsed = Date.now() - parseInt(startTime);
    return Math.max(0, TOTAL_TIME - elapsed);
  };

  const clickAgree = () => {
    history.push("/bod3/assestment");
  };

  const handleTimeUp = () => {
    history.push("/bod3/assestment");
  };

  return (
    <div>
      <Modal token={props.token} profile={props.profile} />

      {general.on_cam && <Camera profile={props.profile} />}
      <WelcomeContainer
        key="bod3-case-a"
        ln="id"
        btnText="Mulai"
        clickAgree={clickAgree}
        welcomeMessage="Anda akan menjalani Situational Judgment Test (SJT) untuk posisi BOD-3. Perhatikan waktu pengerjaan Anda. Anda dapat sewaktu-waktu membuka kembali gambaran umum perusahaan dan petunjuk pengisian ini dengan mengklik di bagian kanan atas sebelah waktu."
        timerComponent={
          <div
            style={{
              backgroundColor: "#fff3cd",
              border: "1px solid #ffc107",
              borderRadius: 8,
              padding: "10px 16px",
              display: "flex",
              alignItems: "center",
              gap: 10,
              width: "50%",
              marginBottom: 8,
            }}
          >
            <span style={{ fontSize: 18 }}>⏱</span>
            <div
              style={{
                display: "flex",
                alignItems: "start",
                flexDirection: "column",
                justifyContent: "",
              }}
            >
              <span style={{ margin: 0, fontSize: 12, color: "#666" }}>
                Waktu pengerjaan sudah berjalan
              </span>
              <Countdown
                date={Date.now() + getRemaining()}
                onComplete={handleTimeUp}
                renderer={({ hours, minutes, seconds }) => (
                  <span
                    style={{
                      fontSize: 20,
                      fontWeight: "bold",
                      color: "#e53935",
                    }}
                  >
                    {hours > 0 ? `${String(hours).padStart(2, "0")}:` : ""}
                    {String(minutes).padStart(2, "0")}:
                    {String(seconds).padStart(2, "0")}
                  </span>
                )}
              />
            </div>
          </div>
        }
      >
        <div className="welcome-mobile">
          <h3 style={{ color: "#00abbd" }}>
            Gambaran umum perusahaan dan Petunjuk pengisian
          </h3>

          <p>
            PT Farmasi Nusantara merupakan perusahaan farmasi nasional yang
            berperan strategis dalam penyediaan produk farmasi dan biologis,
            termasuk dukungan terhadap program kesehatan nasional. Dalam
            menghadapi dinamika industri, perusahaan terus mendorong peningkatan
            efisiensi operasional, kualitas layanan, kepatuhan regulasi, serta
            penguatan kapabilitas organisasi agar tetap berkelanjutan dan
            kompetitif.
          </p>

          <p>
            Anda saat ini berperan sebagai{" "}
            <b>Manajer atau Assistant Manager (BOD-3)</b> yang memiliki tanggung
            jawab strategis-operasional di tingkat unit. Anda diharapkan mampu
            menerjemahkan arahan divisi ke dalam tindakan operasional yang
            efektif, mengelola tim dan koordinasi lintas fungsi di level unit,
            serta mengambil keputusan yang mencerminkan pertimbangan efisiensi,
            kualitas, dan stabilitas operasional unit dalam jangka pendek hingga
            menengah.
          </p>

          <p>
            Dalam tes ini, Anda akan dihadapkan pada sejumlah situasi kerja
            realistis yang mencerminkan tantangan manajerial di lingkungan PT
            Farmasi Nusantara. Setiap situasi diikuti oleh beberapa alternatif
            tindakan yang seluruhnya mungkin dilakukan, namun memiliki tingkat
            efektivitas yang berbeda.
          </p>

          <h4 style={{ marginTop: 20, color: "#78000F" }}>Tugas Anda:</h4>
          <p>Untuk setiap kasus yang disajikan:</p>
          <ul style={{ textAlign: "left", lineHeight: "1.8" }}>
            <li>
              <b>Pilih SATU tindakan yang menurut Anda PALING TEPAT</b>
              <br />→ Tindakan yang paling mencerminkan efektivitas kepemimpinan
              operasional, pertimbangan praktis, dan keselarasan dengan peran
              Manajer/Assistant Manager di tingkat unit.
            </li>
          </ul>

          <h4 style={{ marginTop: 20, color: "#78000F" }}>Petunjuk Penting:</h4>
          <ul style={{ textAlign: "left", lineHeight: "1.8" }}>
            <li>
              Jawablah berdasarkan apa yang seharusnya dilakukan dalam konteks
              profesional, bukan berdasarkan preferensi pribadi semata.
            </li>
            <li>
              Pertimbangkan dampak keputusan terhadap:
              <ul style={{ marginTop: 5 }}>
                <li>Kelancaran dan efektivitas operasional unit</li>
                <li>
                  Kualitas hasil kerja dan kepatuhan terhadap standar serta
                  regulasi
                </li>
                <li>
                  Beban kerja, motivasi, dan kesiapan sumber daya manusia di
                  unit
                </li>
                <li>Efektivitas koordinasi dan kolaborasi dengan unit lain</li>
                <li>
                  Stabilitas kinerja unit dalam jangka pendek hingga menengah
                  (3-12 bulan)
                </li>
              </ul>
            </li>
            <li>
              Tidak ada jawaban benar atau salah secara absolut, namun pilihan
              Anda akan mencerminkan pola pengambilan keputusan dan tingkat
              kompetensi kepemimpinan operasional sesuai tuntutan jabatan BOD-3.
            </li>
          </ul>

          <p style={{ marginTop: 20, fontWeight: "bold" }}>Catatan Penting:</p>
          <p style={{ fontStyle: "italic" }}>
            Kerjakan setiap kasus secara cermat dan konsisten, seolah-olah Anda
            benar-benar berada pada posisi Manajer tersebut di lingkungan kerja
            PT Farmasi Nusantara.
          </p>

          <p style={{ marginTop: 20, fontWeight: "bold", textAlign: "center" }}>
            Selamat mengerjakan!
          </p>
        </div>
      </WelcomeContainer>
    </div>
  );
}
